/**
 * Home-screen install: captures the browser's `beforeinstallprompt` so the
 * app can offer installation on its own terms (a toast, a Settings button)
 * instead of relying on the browser's mini-infobar.
 *
 * Import this early — the event fires once, soon after load.
 */
let deferred = null;
const listeners = new Set();
const notify = () => {
  for (const fn of listeners) fn(!!deferred);
};

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferred = null;
    notify();
  });
}

export function canInstall() {
  return !!deferred;
}

export function onInstallChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Show the native install dialog. Resolves true if the user accepted. */
export async function promptInstall() {
  if (!deferred) return false;
  deferred.prompt();
  let outcome = 'dismissed';
  try {
    ({ outcome } = await deferred.userChoice);
  } catch {
    /* ignore */
  }
  deferred = null;
  notify();
  return outcome === 'accepted';
}
